import React  from 'react'

import FieldString_RenderEditableInlineInput from "../../../../string/render/inline-editable/input-editable-inline"
import EditableInput from "../../../../string/render/inline-editable/input-component"
import FieldTimeDuration from "../../time-duration";

export default class FieldTimeDuration_EditableInlineInput extends FieldString_RenderEditableInlineInput {

    onChange(value:any) {

        // normalizeValue converts the display string (e.g. "8h") to the stored number (e.g. 480)
        // so the comparison is always number vs number, preventing spurious saves on blur
        const normalizedValue = this.props.field.normalizeValue(value)
        if (_.isEqual(this.value, normalizedValue)) {
            return
        }

        this.value          = normalizedValue
        this.renderState    = this._switchToViewOnNextChange ? 'view' : 'edit';

        this.forceUpdate(()=>{
            if (this.props.onChange) this.props.onChange(this.value)
        })
    }

    onEnter(value:any) {
        if (!this.props.onEnter) return

        value = this.props.field.normalizeValue(value)
        this.props.onEnter(value)
    }

    renderEditMode() {

        const classes = Classes(this.props.editClasses, this.props.className, {
            'ui5-txt-no-accent-default' : !this.value,
            'invalid-value'             : !this.props.field.isValueValid(this.value)
        })

        const ButtonComponent : any = _.get(this.props.field.components, 'ButtonComponent', false)

        let value = this.props.field.getDisplayValue(this.value)

        return (
            <EditableInput ref                  = {(r:any)=>this.input = r}
                           className            = {classes}
                           inputClassName       = "ui5-txt-default"
                           value                = {value}
                           trimValue            = {_.isNil(this.props.field.trimValue)?true:this.props.field.trimValue}
                           icon                 = {
                               <React.Fragment>
                                   {_.get(this.props.field.components, 'ValueIcon', false)}
                                   {_.get(this.props.field.components, 'ValuePrefix', false)}
                               </React.Fragment>
                           }
                           button               = {
                               <React.Fragment>
                                   {ButtonComponent && <ButtonComponent field={this.props.field} value={this.value}/>}
                               </React.Fragment>
                           }
                           placeholder          = {this.props.field.placeholder}
                           onBlur               = {this.onBlur}
                           onChange             = {this.onChange.bind(this)}
                           focusOnMount         = {this.props.options?.autofocus}
                           onEnter              = {this.onEnter.bind(this)} // I think bind is truely needed because of cOmponent inheritance
                           onImmediateChange    = {this.props.onImmediateChange}/>
        )
    }
}
